<div class="teaser-cms-container">
  <div class="content">
    <kion-teaser
      *ngIf="component as teaser"
      [title]="teaser.headline"
      [description]="teaser.content"
      [colorSchema]="teaser.colorSchema"
      [contentAlignment]="teaser.textRightAligned === 'true' ? 'right' : 'left'"
      [image]="teaser.mediaNew"
      [link]="teaser.linkRef"
      [fontSize]="teaser.fontSize"
    ></kion-teaser>
  </div>
</div>
